module.exports = __webpack_public_path__ + "static/media/eye.60a5c787.svg";